import { ReactNode } from 'react';

import { Card, CardVariant } from '@components/card';

type AlertVariant = 'error' | 'warning' | 'info' | 'success';

export type AlertProps = {
  children: ReactNode;
  variant: AlertVariant;
};

const ALERT_TYPE_TO_COLOR: Record<AlertVariant, CardVariant> = {
  error: 'red',
  warning: 'orange',
  success: 'green',
  info: 'indigo',
};

export function Alert({ variant, children }: AlertProps) {
  const content =
    typeof children === 'string' ? (
      <span
        dangerouslySetInnerHTML={{
          __html: children,
        }}
      />
    ) : (
      children
    );
  return (
    <Card space={3} variant={ALERT_TYPE_TO_COLOR[variant]}>
      {content}
    </Card>
  );
}
